/**
* @license Copyright (c) 2003-2015, CKSource - Frederico Knabben. All rights reserved.
* For licensing, see LICENSE.md or http://ckeditor.com/license
*/

import OS_SaveContent from '@/services/paper/outline/saveContent';
import store from '@/store';

// Save Paper Outline in the Organize Tab
(() => {
    CKEDITOR.plugins.add('saveOutline', {
		icons: 'saveOutline', // %REMOVE_LINE_CORE%
        hidpi: true, // %REMOVE_LINE_CORE%
        init(editor) {
			store.commit('paperEdit/autoSave/START_TIMER');

            editor.addCommand('saveOutline', {
				exec(editor) {
                    if (editor.fire('saveDocument')) {
						OS_SaveContent();
                    }
                },//e:exec
            }); // end addCommand save
			
			editor.ui.addButton('SaveOutline', {
				label: 'Save',
                command: 'saveOutline',
            });

			editor.on('destroy', (event) => {
                store.commit('paperEdit/autoSave/CLEAR_TIMER');
            });

            editor.setKeystroke(CKEDITOR.CTRL + 83 /*S*/, 'saveOutline');
        }//e:init
    });//e:plugins.add

})();
